import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './containers/index';
import './locale/i18n';

ReactDOM.render(<App />, document.getElementById('app'));
